const env = {
  apiLink: "https://api.comtracked.com/",
  // apiLink: "http://localhost:3001/",
  publishableKey:
    "pk_test_51QkPfOCA6VTFrZJ6sU5nOBNFBdhvfAGQRcgLfQwai3Fpc6s7UX0mqWFrcH8WgA32FDUGFYTHkjcTwVDeSRanevMy00BFhwehKk",
  //  apiLink: "http://192.168.11.138:3001/",
};

export default env;
